import React, { useState, useEffect } from 'react';
import { Pie, Line,Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';
import { ShoppingBag, Percent, Box } from 'lucide-react';
import { TbCategory } from "react-icons/tb";
import { MdOutlineInventory2 } from "react-icons/md";
import { MdOutlineDiscount } from "react-icons/md";
import AdminHome from './AdminHome'
import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';

ChartJS.register(
    ArcElement,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Tooltip,
    Legend,
    Title
  );

const ProductView = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsResponse] = await Promise.all([
          fetch('/api/all/products'),
        ]);
        
        const productsData = await productsResponse.json();
       
        
        setProducts(productsData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
 
  // Product Dashboard Calculations
  const totalProducts = products.length;
  const totalInventory = products.reduce((sum, product) =>
    sum + product.size.reduce((acc, size) => acc + size.quantity, 0), 0);
  const averageDiscount = (products.reduce((sum, product) => sum + product.discount, 0) / totalProducts).toFixed(2);

  // Size distribution data
  const sizeCounts = products.flatMap(product => product.size)
    .reduce((acc, size) => {
      acc[size.size] = (acc[size.size] || 0) + size.quantity;
      return acc;
    }, {});

  const sizeChartData = {
    labels: Object.keys(sizeCounts),
    datasets: [{
      data: Object.values(sizeCounts),
      backgroundColor: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#4BC0C0',
        '#9966FF',
        '#FF9F40'
      ]
    }]
  };

  // Price range data
  const priceRanges = [
    { range: '₹0-₹5000', count: products.filter(p => p.salePrice < 5000).length },
    { range: '₹5000-₹10000', count: products.filter(p => p.salePrice >= 5000 && p.salePrice < 10000).length },
    { range: '₹10000+', count: products.filter(p => p.salePrice >= 10000).length }
  ];

  const priceChartData = {
    labels: priceRanges.map(p => p.range),
    datasets: [{
      label: 'Number of Products',
      data: priceRanges.map(p => p.count),
      borderColor: 'rgba(75, 192, 192, 1)',
      backgroundColor: 'rgba(75, 192, 192, 0.3)',
      pointBackgroundColor: 'rgba(75, 192, 192, 1)',
      pointBorderColor: 'rgba(75, 192, 192, 1)',
      borderWidth: 2,
      tension: 0.4
    }]
  };



  return (
    <div>
          <div className="flex flex-col gap-6">
    

    <div class="tf-product-info-delivery-return">
    <div class="row">
       <div className="col-lg-12 mb-4" style={{display:"flex",gap:"5px" ,overflowX:"scroll"}}>
        <div className='col-xl-3'style={{backgroundColor:"#dcdcdc70"}}>
            <div class="tf-product-delivery" >
                <div class="icon">
                    <i class="icon-delivery-time"></i>
                </div>
                <p><ShoppingBag size={24} color="#3b82f6" /> Total Products <span class="fw-7"> {totalProducts}</span></p>
            </div>
        </div>
        <div className='col-xl-3' style={{backgroundColor:"#d4faeda6"}}>
            <div class="tf-product-delivery mb-0">
                <div class="icon">
                    <i class="icon-return-order"></i>
                </div>
                <p><TbCategory size={24} color="#3b82f6"/> Total Category <span class="fw-7"> {totalProducts}</span></p>
            </div>
        </div>
        <div className='col-xl-3' style={{backgroundColor:"#ffe1e1b0"}}>
            <div class="tf-product-delivery">
                <div class="icon">
                    <i class="icon-delivery-time"></i>
                </div>
                <p><MdOutlineInventory2 size={24} color="#3b82f6"/> Total Inventory <span class="fw-7"> {totalInventory}</span></p>
            </div>
        </div>
        <div className='col-xl-3' style={{backgroundColor:"beige"}}>
            <div class="tf-product-delivery mb-0 ">
                <div class="icon">
                    <i class="icon-return-order"></i>
                </div>
                <p><MdOutlineDiscount size={24} color="#3b82f6" backgroundColor="red"/> Average Discount <span class="fw-7"> 0</span></p>
            </div>
        </div>
        </div>
    
        <div class="col-xl-6 col-12 col-md-6">
                <div class="tf-product-delivery mb-0">
                       <h6>Size Distribution</h6>
                       <div style={{ height: '288px' }}>
          <Pie
            data={sizeChartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: 'right',
                  labels: { font: { size: 12 } }
                }
              }
            }}
          />
        </div>
                </div>
        </div>
    
    
        <div class="col-xl-6 col-12 col-md-6">
                <div class="tf-product-delivery mb-0">
                       <h6>Price Range Distribution</h6>
                       <div style={{ height: '288px' }}>
          <Line
            data={priceChartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: 'top' },
                tooltip: {
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  titleColor: 'white',
                  bodyColor: 'white'
                }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: 'Number of Products'
                  }
                },
                x: {
                  title: {
                    display: true,
                    text: 'Price Ranges'
                  }
                }
              }
            }}
          />
        </div>
                </div>
        </div>
    
    
    </div>
    </div>
    
    <br/>
    
      {/* Bottom row - Charts */}
    
    <div className='tf-product-info-delivery-return'>
          <div className='row'>
        
    
        
    
          </div>
    </div>
    </div>
    </div>
  )
}

export default ProductView